import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiRouterPalletService } from '../../../../api/elite/routes/pallet.service';
import { Pallet } from '../../../../api/elite/types/pallet';
import { GroupedPropertiesPackingBox } from 'src/app/common/scanner/models/pallet';
import { ApiFilesBarCodeService } from '../../../../api/files/routes/bar-code.service';
import { PrintLabelPalletDto } from '../../../../api/local/dto/label-pallet.dto';

@Injectable({
  providedIn: 'root',
})
export class PalletViewRegisterApiService {
  protected readonly apiPalletRouter = inject(ApiRouterPalletService);
  protected readonly localApiPortLabelRouter = inject(ApiFilesBarCodeService);

  constructor() {}

  getPalletData(palletId: number): Observable<{
    pallet: Pallet;
    boxes: GroupedPropertiesPackingBox[];
  }> {
    return this.apiPalletRouter.infoToDisplay(palletId).pipe(
      map((data) => {
        const { boxes, ...pallet } = data;
        return {
          pallet: {
            id: pallet.id,
            createdAt: pallet.createdAt,
            completedDate: pallet.completedAt,
          },
          boxes: boxes.map((box) => new GroupedPropertiesPackingBox(box)),
        };
      })
    );
  }

  finishPallet(palletId: number): Observable<void> {
    return this.apiPalletRouter.finishPallet(palletId);
  }

  printZebraLabelPallet(
    data: PrintLabelPalletDto
  ): Observable<{ data: string }> {
    return this.localApiPortLabelRouter.getPalletLabelZpl(data);
  }
}
